import logo from './logo.svg';
import './App.css';
import React, { useState } from 'react';
import axios from 'axios'; // axios 임포트
//export default AxiosButton; 

function App() {
  const [data, setData] = useState(null);
 // const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleCallApi = async () => {
   setLoading(true);
  // setError(null); // 이전 에러 초기화

    try {
      // 1. axios.get()은 내부적으로 JSON 파싱을 자동으로 수행합니다.
      const response = await axios.get('/api/health');
      
      // 2. 응답 데이터는 항상 .data 안에 담겨 있습니다.
      setData(response.data);
    } catch (err) {
      // 3. fetch와 달리 400, 500번대 에러도 catch 블록에서 바로 잡힙니다.
//      setError('데이터를 불러오는 중 문제가 발생했습니다.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
         Jack Test Web
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      <h3>Axios API 호출</h3>
      <button onClick={handleCallApi} disabled={loading}>
        {loading ? '로딩 중...' : '데이터 가져오기'}
      </button>
      {data && (
        <div style={{ marginTop: '20px', backgroundColor: '#444', padding: '10px' }}>
          <h4>받아온 내용: {data}</h4>
        </div>
      )}      
    </header>
      
    </div>
  );
}

export default App;
